import React from 'react';
import { styled } from '@mui/system';
import {
  Grid,
  Typography,
  Button,
  Tooltip,
  tooltipClasses
} from '@mui/material';
import { WarningRounded } from '@mui/icons-material';
import { getWindowHeight } from '#helper';

export const OverviewContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(),
  paddingTop: theme.spacing(3),
  height: 'calc(100% - 64px)',
  textAlign: 'left',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.down('sm')]: {
    '& > div:first-of-type': {
      padding: '0 32px'
    }
  },
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
    paddingBottom: 0
  },
  '& .leftSidebar': {
    height: '100%'
  },
  '& .leftSidebar > div.events': {
    [theme.breakpoints.up('md')]: {
      height: 'calc(100% - 48px)',
      overflowY: 'auto',
      '&::-webkit-scrollbar-track': {
        WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
        borderRadius: 10,
        backgroundColor: '#F5F5F5'
      },
      '&::-webkit-scrollbar': {
        width: 8,
        backgroundColor: '#F5F5F5'
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: 10,
        WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
        backgroundColor: '#a0a0a0'
      }
    }
  },
  '&.scrolled .leftSidebar > div.events': {
    [theme.breakpoints.up('md')]: {
      width: 225,
      position: 'fixed',
      top: 10,
      height: getWindowHeight() - 20
    }
  },
  '@media screen and (max-height: 500px)': {
    height: 'auto'
  }
}));

export const ApplianceHeader = styled('div')({});

export const ButtonRoot = styled(Button)({
  textTransform: 'unset !important'
});

export const ApplianceLabel = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isOff'
})(({ theme, isOff }) => ({
  display: 'flex',
  alignItems: 'center',
  margin: '0 0 0 5px',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    marginBottom: 0
  },
  ...(isOff && {
    color: '#667'
  })
}));

export const ApplianceLabelText = styled('span')({
  maxWidth: 260,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  verticalAlign: 'middle',
  textOverflow: 'ellipsis'
});

export const HeaderGrid = styled(Grid)({});

export const DateRangeArea = styled(Grid)(({ theme }) => ({
  display: 'flex',
  '&.MuiGrid-item': {
    [theme.breakpoints.up('sm')]: {
      paddingBottom: 16,
      paddingTop: 8,
      justifyContent: 'flex-end'
    }
  },
  '& p.Mui-error': {
    position: 'absolute',
    margin: 0,
    marginTop: 4,
    padding: '8px 14px',
    top: 60,
    background: '#FF4635',
    color: '#FFF',
    width: '100%',
    zIndex: 10,
    boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    borderRadius: 4
  }
}));

export const WarningContainer = styled('div')({
  marginRight: '5px',
  marginLeft: '-4px',
  height: 24,
  display: 'flex'
});

export const StyledWarningIcon = styled(WarningRounded)({
  color: '#FACE31'
});

export const ApplianceUIDContainer = styled(Typography)({
  display: 'block',
  marginLeft: 6,
  lineHeight: '1.3em'
});

export const ApplianceUIDTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: 'unset'
  }
}));

export const ApplianceUIDLabel = styled('span')({
  display: 'block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});

export const ApplianceInfoLabel = styled('div')({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});
